import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { cloudSaveNames } from "./emulator/cloudSaves";
import { accountAtLoad, settleProfile, tokenAtLoad } from "./emulator/profiles";
import { settlePreferences } from "@common/preferences";
import { recordVisit } from "@common/visit";
import "./index.css";

const container = document.getElementById("root")!;
recordVisit();

// Before anything reads the browser's saves and settings, make them the
// signed-in account's.
settleProfile(
  accountAtLoad(),
  () => {
    container.textContent = "Switching to this account's saves…";
  },
  {
    cloudNames: async () => {
      const token = tokenAtLoad();
      return token ? cloudSaveNames(token) : null;
    },
  },
)
  .then(() => settlePreferences())
  .then(() =>
    ReactDOM.createRoot(container).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    ),
  );
